export default "__VITE_ASSET__CYmFIAw7__"